<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input
          placeholder="证件号码"
          v-model.trim="idCard"
          class="handle-input mr10"
        ></el-input>
        <el-input
          placeholder="用户名称"
          v-model.trim="userName"
          class="handle-input mr10"
        ></el-input>
        <el-input
          placeholder="保荐人"
          v-model.trim="inviter"
          class="handle-input mr10"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getData(1)"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column width="80px" align="center" label="序号" type="index">
          <template #default="scope">
            <span>{{
              data.total - ((data.current - 1) * 20 + scope.$index)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="invitationCode"
          align="center"
          label="保荐码"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="realname"
          label="用户名称"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="证件账号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="username"
          align="center"
          label="创建账号"
        ></el-table-column>
        <el-table-column align="center" label="保荐人">
          <template #default="scope">{{ scope.row.inviter || "-" }} </template>
        </el-table-column>
        <el-table-column label="认证时间" align="center">
          <template #default="scope"
            >{{ $utils.formatDate(scope.row.auditTime, "yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      itemData: {},
      editVisible: false,
      loading: false,
      reject_dialog: false,
      auditRemark: "",
      idCard: "",
      userName: "",
      inviter: "",
    };
  },
  methods: {
    async getData(page) {
      const params = {
        pageSize: 20,
        currentPage: page,
        idCard: this.idCard,
        inviter: this.inviter,
        userName: this.userName,
      };
      this.$loading.start();
      const res = await this.$api.account.getPersonalList(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(data) {
      this.$router.push(`/account/personal/${data.id}`);
    },
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "护照";
        case 3:
          return "其他";
      }
    },
    // 提交审核
    async companyAudit(params) {
      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        const res = await this.$api.authe.personalAudit(params);
        this.loading = false;
        this.$loading.done();
        if (res.code === 10200) {
          this.getData(this.data.current);
          this.editVisible = false;
          this.reject_dialog = false;
          this.auditRemark = "";
          if (params.status === 1) {
            this.$message.success("审核通过已通知该用户！");
          } else {
            this.$message.success("驳回成功！");
          }
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    // 通过
    adopt() {
      const params = {
        userId: this.itemData.id,
        status: 1,
        auditRemark: "",
      };
      this.companyAudit(params);
    },

    // 驳回
    reject() {
      if (!this.auditRemark) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const params = {
        userId: this.itemData.id,
        status: 2,
        auditRemark: this.auditRemark,
      };
      this.companyAudit(params);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  max-width: 300px;
  display: inline-block;
}

.handle-box {
  display: flex;
  margin-bottom: 20px;
}

.editVisible-dialog {
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      padding: 0;
      &:first-child {
        td {
          border-top: 1px solid #ebeef5;
        }
      }
      td {
        padding: 10px;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        &:first-child {
          width: 130px;
          border-left: 1px solid #ebeef5;
        }
      }
    }
  }
  .upload-file {
    height: 40px;
    line-height: 40px;
  }
  .file-img {
    img {
      width: 200px;
      vertical-align: top;
      &:first-child {
        margin-right: 10px;
      }
    }
  }
}
</style>